import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, ButtonListItemSize } from '@as/cotopaxi';
import { capitalize } from '@as-react/common-utils';
import { Stack, TextAlpha } from '@yonderland/andes-react';
export const FilterLink = ({ items, toggleFilterValue }) => (_jsx(ButtonList, { stateLabel: true, size: ButtonListItemSize.MEDIUM, buttons: items.map((item) => ({
        key: item.filterKey,
        noBubble: true,
        text: (_jsxs(Stack, { gap: "3", children: [_jsx(TextAlpha, { as: "span", strong: item.active, children: capitalize(item.name) }), _jsxs(TextAlpha, { as: "span", color: "subtle", children: ["(", item.itemCount, ")"] })] })),
        onClick: (e) => toggleFilterValue(e, item),
    })) }));
